import {fromJS} from 'immutable';
import {
  AUDIO_SET_ENABLED,
  AUDIO_SET_VAD_ENABLED,
  AUDIO_SET_STT_ENABLED,
  AUDIO_START,
  AUDIO_STOP,
  AUDIO_TRANSCRIBE_REQUEST,
  AUDIO_TRANSCRIBE_RESULT,
  AUDIO_ERROR,
  AUDIO_SET_HEARING,
  AUDIO_SET_ROBOT_SPEAKING,
} from './consts'

const initialState = fromJS({
  enabled: true,
  vadEnabled: true,
  sttEnabled: true,
  isListening: false,
  isTranscribing: false,
  lastError: null,
  hearing: 'silence',
  robotSpeaking: false,
})

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action) => {
  switch (action.type) {
    case AUDIO_SET_ENABLED:
      return state.set('enabled', action.enabled)

    case AUDIO_SET_VAD_ENABLED:
      return state.set('vadEnabled', action.enabled)

    case AUDIO_SET_STT_ENABLED:
      return state.set('sttEnabled', action.enabled)

    case AUDIO_START:
      return state.set('isListening', true)
        .set('lastError', null)

    case AUDIO_STOP:
      return state.set('isListening', false)

    case AUDIO_TRANSCRIBE_REQUEST:
      return state.set('isTranscribing', true)

    case AUDIO_TRANSCRIBE_RESULT:
      return state.set('isTranscribing', false)

    case AUDIO_ERROR:
      return state.set('lastError', String(action.error || 'unknown audio error'))
        .set('isTranscribing', false)

    case AUDIO_SET_HEARING:
      return state.set('hearing', action.hearing)

    case AUDIO_SET_ROBOT_SPEAKING:
      return state.set('robotSpeaking', !!action.speaking)

    default:
      return state;
  }
}
;
